module.exports = __webpack_public_path__ + "static/media/h4.15d302bf.svg";